import {
	INSIGHTS_AP_REQUEST_GET,
	INSIGHTS_AP_RESPONSE_GET_FAIL,
	INSIGHTS_AP_RESPONSE_GET_SUCCESS,
	INSIGHTS_CLIENT_REQUEST_GET,
	INSIGHTS_CLIENT_REQUEST_GET_FAIL,
	INSIGHTS_CLIENT_REQUEST_GET_SUCCESS,
} from '../constants/insightConstants';

/**
 * Reducer function for managing Insights state.
 *
 * This reducer handles actions related to fetching Insights data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the Insights.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const apInsightsReducer = (state = { apInsights: {} }, action) => {
	switch (action.type) {
		case INSIGHTS_AP_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case INSIGHTS_AP_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				apInsights: action.payload,
			};
		case INSIGHTS_AP_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const clientInsightsReducer = (
	state = { clientInsights: {} },
	action,
) => {
	switch (action.type) {
		case INSIGHTS_CLIENT_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case INSIGHTS_CLIENT_REQUEST_GET_SUCCESS:
			return {
				...state,
				loading: false,
				clientInsights: action.payload,
			};
		case INSIGHTS_CLIENT_REQUEST_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
